// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from '@emotion/styled';
import { number, string } from 'prop-types';
import { DynamicIcon, iconNames } from 'lucide-react/dynamic.mjs';

const StyledIcon = styled.span`
  display: inline-flex;
  line-height: 0;
`;

const LucideIconComponent = ({ icon, color, size, strokeWidth }) => {
  const normalizedName = icon.trim().toLowerCase();
  const iconName = iconNames.includes(normalizedName) ? normalizedName : 'circle-help';

  return (
    <StyledIcon>
      <DynamicIcon
        aria-hidden
        color={ color }
        name={ iconName }
        size={ size }
        strokeWidth={ strokeWidth }
      />
    </StyledIcon>
  );
};

LucideIconComponent.propTypes = {
  icon: string,
  color: string,
  size: number,
  strokeWidth: number,
};

const LucideIcon = {
  label: 'Lucide Icon',
  fields: {
    icon: {
      type: 'text',
      label: 'Icon name',
      placeholder: 'shopping-cart',
    },
    color: { type: 'text', label: 'Color' },
    size: {
      type: 'number',
      label: 'Size',
      min: 1,
      max: 512,
    },
    strokeWidth: {
      type: 'number',
      label: 'Stroke width',
      min: 0.25,
      max: 8,
      step: 0.25,
    },
  },
  defaultProps: {
    icon: 'star',
    color: '#0f172a',
    size: 24,
    strokeWidth: 2,
  },
  // eslint-disable-next-line react/jsx-props-no-spreading
  render: props => <LucideIconComponent { ...props } />,
};

// eslint-disable-next-line import/prefer-default-export
export { LucideIcon };
